import styled from "@emotion/styled"

const Container = styled('div')(() => ({
    position: 'relative',
    height: '1340px',
    justifyContent: 'center',
    display: 'flex',
    zIndex: 1,
    background: '#f5f5f5',
}))

export default Container 
